// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"19":"968291b9","332":"48074e21","386":"844c8a0c","407":"43b97049","605":"417343f0","887":"fe77467f"}[chunkId] + ".css";
};